import { useState, useEffect } from "react";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import Swal from "sweetalert2";
// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images

import MDButton from "components/MDButton";

import { useNavigate, useSearchParams } from "react-router-dom";
import ExploreAllDialog from "layouts/dialogModals/ExploreAllDialog";
import { useMediaQuery } from "react-responsive";
import { Divider, IconButton, Menu, MenuItem } from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { blockUser } from "services/apiService";
import { reportUser } from "services/apiService";
import { unBlockUser } from "services/apiService";
import { toast } from "react-toastify";
import ShowBlockedUsers from "layouts/dialogModals/ShowBlockedUsersDialog";
import { useDispatch, useSelector } from "react-redux";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function Header({
  // profileData,
  followUnfollowTrigger,
  statusLoader,
  refresher,
}) {
  let navigate = useNavigate();

  const dispatch = useDispatch();

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const { profileData, isLoadingProfile } = useSelector(
    (state) => state.profileData
  );

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [searchParams] = useSearchParams();
  const [exploreAllDialogBoolean, setExploreAllDialogBoolean] = useState(false);
  const [showBlockedUsersDialogBoolean, setShowBlockedUsersDialogBoolean] =
    useState(false);
  const [showTab, setShowTab] = useState("");
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const openExploreAllDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setShowTab(value);
    setExploreAllDialogBoolean(true);
  };

  const handleClose = () => {
    setExploreAllDialogBoolean(false);
    setShowBlockedUsersDialogBoolean(false);
  };

  const handleProfileEditClick = () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    navigate("/edit-profile");
  };

  const handleReport = async (uselessState, type, identifier, isBlocked) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (type === "block") {
      if (!isBlocked) {
        const blockUserRes = await blockUser(identifier);
        // console.log("blockUserRes", blockUserRes);
        if (blockUserRes.status === 200) {
          toast.success(
            `User successfully block, You wont see thier post until you unblock them`,
            {
              style: {
                fontSize: "15px",
              },
            }
          );
        }
        refresher();
      } else {
        const unBlockUserRes = await unBlockUser(identifier);
        // console.log("unBlockUserRes", unBlockUserRes);
        if (unBlockUserRes.status === 200) {
          toast.success(
            `User successfully unblocked, Follow to see thier posts`,
            {
              style: {
                fontSize: "15px",
              },
            }
          );
        }

        refresher();
      }
    } else {
      const reportUserRes = await reportUser(identifier);
      // console.log("reportUserRes", reportUserRes);
      if (reportUserRes.status === 200) {
        Swal.fire({
          title: "Thank you reporting",
          text: "We will review and take the necessary action against this.",
          icon: "success",
          background: "darkgray",
          width: "360px",
          // confirmButtonText: "Remove",
          // confirmButtonColor: "red",
          // showCancelButton: true,
        });
      }
      refresher();
    }
  };

  const handleShowBlockedUsers = (uselessState) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setShowBlockedUsersDialogBoolean(true);
  };

  // console.log("proD", profileData);

  return (
    <MDBox position="relative">
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="12.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: `url(${profileData?.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        elevation={0}
        sx={{
          backgroundColor: "#00000000",
          position: "relative",
          mt: -6,
          // mx: 3,
          // py: 2,
          // px: 2,
        }}
      >
        <Grid
          container
          // spacing={3}
          alignItems="center"
        >
          <Grid
            item
            container
            xs={12}
            md={6}
            lg={6}
            sx={
              {
                // paddingLeft: "5px !important",
                // paddingTop: "10px !important",
              }
            }
          >
            <MDBox
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "2rem",
                justifyContent: isTabletOrMobile ? "" : null,
                padding: "1rem",
              }}
            >
              <MDBox sx={{}}>
                <MDAvatar
                  src={profileData?.profilePic}
                  alt="profile-image"
                  size="xxl"
                  shadow="sm"
                  sx={{ border: "1px solid #6a6a6a", backgroundColor: "#000" }}
                  imgProps={{ style: { height: "100%", width: "100%" } }}
                />
                {localStorage.userNameSingh ===
                  searchParams.get("username") && (
                  <IconButton
                    sx={{
                      border: "1px solid #6a6a6a",
                      backgroundColor: "#000",
                      fontSize: "15px",
                      marginTop: -8,
                      marginLeft: 8,
                      // alignItems: "end",
                      // position: "absolute",
                      // fontSize: "45px",
                      // top: isDesktopOrLaptop ? "36%" : "35%",
                      // left: isDesktopOrLaptop ? "51%" : "45%",
                      // height: isDesktopOrLaptop ? "200px" : "100px",
                      // width: isDesktopOrLaptop ? "200px" : "100px",
                      // cursor: "pointer",
                    }}
                    onClick={() => handleProfileEditClick()}
                  >
                    <ModeEditOutlineOutlinedIcon style={{ color: "#ff9607" }} />
                  </IconButton>
                )}
              </MDBox>

              <MDBox>
                <MDTypography variant="h5" fontWeight="medium" color="singh">
                  {profileData?.username}
                </MDTypography>
                <MDTypography variant="h6" fontWeight="regular">
                  {profileData?.fullName}
                </MDTypography>
              </MDBox>
              {/* <IconButton sx={{ color: "#fff" }}>
                <MoreVertIcon />
              </IconButton> */}
            </MDBox>
            <MDBox sx={{ width: "55%", paddingLeft: "1.5rem" }}>
              <MDTypography>Bio</MDTypography>
              <MDTypography
                variant="button"
                fontWeight="regular"
                sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
              >
                {profileData?.bio}
              </MDTypography>
            </MDBox>
            {localStorage.userNameSingh !== profileData?.username &&
              isTabletOrMobile && (
                <MDBox
                  sx={{
                    width: "45%",
                    textAlign: "center",
                  }}
                >
                  {profileData?.showUnBlocked ? (
                    <MDButton
                      disabled={statusLoader}
                      color="singh"
                      onClick={() =>
                        handleReport(
                          "uselessState",
                          "block",
                          profileData?.username,
                          profileData?.showUnBlocked
                        )
                      }
                    >
                      Unblock
                    </MDButton>
                  ) : (
                    <MDButton
                      disabled={statusLoader}
                      color="singh"
                      onClick={followUnfollowTrigger}
                    >
                      {profileData?.isFollowing ? "Unfollow" : "Follow"}
                    </MDButton>
                  )}

                  <PopupState variant="popover" popupId="demo-popup-menu">
                    {(popupState) => (
                      <>
                        <IconButton {...bindTrigger(popupState)}>
                          <MoreVertIcon sx={{ color: "#fff" }} />
                        </IconButton>
                        <Menu {...bindMenu(popupState)}>
                          {localStorage.userNameSingh !==
                            searchParams.get("username") && (
                            <MenuItem
                              onClick={() =>
                                handleReport(
                                  popupState.close(),
                                  "block",
                                  profileData?.username,
                                  profileData?.showUnBlocked
                                )
                              }
                            >
                              {profileData?.showUnBlocked ? "Unblock" : "Block"}{" "}
                              {profileData?.username}
                            </MenuItem>
                          )}

                          <MenuItem
                            onClick={() =>
                              handleShowBlockedUsers(popupState.close())
                            }
                          >
                            Show blocked users
                          </MenuItem>
                          {localStorage.userNameSingh !==
                            searchParams.get("username") && (
                            <MenuItem
                              onClick={() =>
                                handleReport(
                                  popupState.close(),
                                  "account",
                                  profileData?.username
                                )
                              }
                            >
                              Report Account
                            </MenuItem>
                          )}
                        </Menu>
                      </>
                    )}
                  </PopupState>
                </MDBox>
              )}
          </Grid>

          <Grid
            item
            container
            xs={12}
            md={6}
            lg={6}
            sx={
              {
                // paddingLeft: "5px !important",
                // paddingTop: "10px !important",
              }
            }
          >
            <MDBox
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                marginBottom: "1rem",
                marginTop: isTabletOrMobile && "1rem",
                // marginLeft: isDesktopOrLaptop && "250px",
              }}
            >
              <MDBox sx={{ width: "100px" }}>
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData?.totalPost}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Posts
                </MDTypography>
              </MDBox>
              &nbsp;
              <MDBox
                sx={{ width: "100px", cursor: "pointer" }}
                onClick={() => openExploreAllDialog(0)}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData?.following}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Following
                </MDTypography>
              </MDBox>
              &nbsp;
              <MDBox
                sx={{ width: "100px", cursor: "pointer" }}
                onClick={() => openExploreAllDialog(1)}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData?.followers}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Followers
                </MDTypography>
              </MDBox>
              {!isTabletOrMobile && (
                <PopupState variant="popover" popupId="demo-popup-menu">
                  {(popupState) => (
                    <>
                      <IconButton {...bindTrigger(popupState)}>
                        <MoreVertIcon sx={{ color: "#fff" }} />
                      </IconButton>
                      <Menu {...bindMenu(popupState)}>
                        {localStorage.userNameSingh !==
                          searchParams.get("username") && (
                          <MenuItem
                            onClick={() =>
                              handleReport(
                                popupState.close(),
                                "block",
                                profileData?.username,
                                profileData?.showUnBlocked
                              )
                            }
                          >
                            {profileData?.showUnBlocked ? "Unblock" : "Block"}{" "}
                            {profileData?.username}
                          </MenuItem>
                        )}

                        <MenuItem
                          onClick={() =>
                            handleShowBlockedUsers(popupState.close())
                          }
                        >
                          Show blocked users
                        </MenuItem>
                        {localStorage.userNameSingh !==
                          searchParams.get("username") && (
                          <MenuItem
                            onClick={() =>
                              handleReport(
                                popupState.close(),
                                "account",
                                profileData?.username
                              )
                            }
                          >
                            Report Account
                          </MenuItem>
                        )}
                      </Menu>
                    </>
                  )}
                </PopupState>
              )}
            </MDBox>
            {localStorage.userNameSingh !== profileData?.username &&
              !isTabletOrMobile && (
                <MDBox sx={{ width: "100%", textAlign: "center" }}>
                  {profileData?.showUnBlocked ? (
                    <MDButton
                      disabled={statusLoader}
                      color="singh"
                      onClick={() =>
                        handleReport(
                          "uselessState",
                          "block",
                          profileData?.username,
                          profileData?.showUnBlocked
                        )
                      }
                    >
                      Unblock
                    </MDButton>
                  ) : (
                    <MDButton
                      disabled={statusLoader}
                      color="singh"
                      onClick={followUnfollowTrigger}
                    >
                      {profileData?.isFollowing ? "Unfollow" : "Follow"}
                    </MDButton>
                  )}
                </MDBox>
              )}
          </Grid>

          {/* <Grid
            item
            container
            xs={4}
            // md={6}
            // lg={6}
            sx={{
              border: "1px solid red",
              // paddingLeft: "5px !important",
              // paddingTop: "10px !important",
            }}
          >
            <MDBox sx={{ width: "100px" }}>
              <MDTypography>Bio</MDTypography>
              <MDTypography
                variant="button"
                fontWeight="regular"
                sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
              >
                {profileData.bio}
              </MDTypography>
            </MDBox>
          </Grid> */}
          {/* <Grid
            item
            xs={6}
            md={6}
            lg={4}
            sx={{
              display: isDesktopOrLaptop && "flex",
              justifyContent: isDesktopOrLaptop && "space-between",
              paddingTop: isDesktopOrLaptop && "65px !important",
            }}
          >
            <MDBox
              height="100%"
              sx={{
                marginBottom: "20px",
                marginLeft: isDesktopOrLaptop && "-100px",
              }}
              lineHeight={1}
            >
              <MDTypography variant="h5" fontWeight="medium" color="singh">
                {profileData.username}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="regular">
                {profileData.fullName}
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "space-around",
                textAlign: "center",
                marginLeft: isDesktopOrLaptop && "250px",
              }}
            >
              <MDBox sx={{ width: "100px" }}>
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData.totalPost}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Posts
                </MDTypography>
              </MDBox>
              &nbsp;
              <MDBox
                sx={{ width: "100px" }}
                onClick={() => openExploreAllDialog()}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData.following}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Following
                </MDTypography>
              </MDBox>
              &nbsp;
              <MDBox
                sx={{ width: "100px" }}
                onClick={() => openExploreAllDialog()}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  {profileData.followers}
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
                >
                  Followers
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox
              sx={{
                position: isDesktopOrLaptop && "absolute",
                // top: "135px",
                // right: "110px",
                top: "40%",
                right: "10%",
              }}
            >
              {localStorage.userNameSingh !== profileData.username && (
                <Grid item xs={12} md={2} textAlign="center">
                  <MDButton color="singh" onClick={statusUpdate}>
                    {profileData.isFollowing ? "Unfollow" : "Follow"}
                  </MDButton>
                </Grid>
              )}
            </MDBox>
          </Grid> */}
        </Grid>

        {/* <Grid item xs={12} md={6} lg={4}>
          <MDBox sx={{ width: "100px" }}>
            <MDTypography>Bio</MDTypography>
            <MDTypography
              variant="button"
              fontWeight="regular"
              sx={{ fontSize: isTabletOrMobile ? "10px" : "15px" }}
            >
              {profileData.bio}
            </MDTypography>
          </MDBox>
        </Grid> */}
      </Card>

      {showBlockedUsersDialogBoolean && (
        <ShowBlockedUsers
          openStatus={showBlockedUsersDialogBoolean}
          onClose={() => handleClose()}
        />
      )}

      {exploreAllDialogBoolean && (
        <ExploreAllDialog
          openStatus={exploreAllDialogBoolean}
          showTab={showTab}
          onClose={() => handleClose()}
        />
      )}
    </MDBox>
  );
}

// Setting default props for the Header
// Header.defaultProps = {
//   children: "",
// };

// Typechecking props for the Header
// Header.propTypes = {
//   children: PropTypes.node,
// };

export default Header;
